export default __webpack_public_path__ + "static/media/HK.63831459.jpg";